export const VegMark = ({ diet, testId, className = "" }) => {
  const veg = diet !== "non-veg";
  const c = veg ? "#1E8A3A" : "#C62828";
  return (
    <span data-testid={testId} role="img" aria-label={veg ? "Veg" : "Non-veg"} title={veg ? "Veg" : "Non-veg"}
      className={`inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[3px] bg-white ${className}`} style={{ boxShadow: `inset 0 0 0 1.6px ${c}` }}>
      <span className="h-[8px] w-[8px] rounded-full" style={{ background: c }} />
    </span>
  );
};
